var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('wx-open-launch-weapp',{staticClass:"wx-weapp",attrs:{"id":_vm.id,"appid":_vm.appid,"username":_vm.username,"path":_vm.path},on:{"click":_vm.weappClick}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v(" <style> .bind-btn{ opacity: 0; height:1000px; } </style> <div class=\"bind-btn\">打开小程序</div> ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }